import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Col, Form, Row, Table } from 'react-bootstrap'
import { Link, useSearchParams } from 'react-router-dom'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { fnDateEn } from '../../../helper/fnDateEn'
import { listPayrollAPI } from '../../../services/income/payroll'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import { FaAnglesRight } from 'react-icons/fa6'

export default function DetailIncomePrintPage() {
  let [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const orgId = searchParams.get('orgId')
  const totalLimits = 20
  const [page, setPage] = useState(1)
  const [bodyFilter, setBodyFilter] = useState()
  const [totalRows, setTotalRow] = useState(0)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const body = {
      page: 1,
      orgId,
      paymentPeriodDate: fnDateEn(id).format('YYYYMM')
    }
    if (orgId) {
      fnGetData(body)
    }
  }, [orgId, id])
  const [dataTable, setDataTable] = useState([])
  const fnGetData = async (body) => {
    setIsLoading(true)
    setBodyFilter(body)
    setPage(body.page)
    const resp = await listPayrollAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRow(resp.totalRows)
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }

  const { control, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: ''
    }
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: d.search
    }
    fnGetData(body)
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>
          <div>
            <Link
              to={-1}
              className={`my-auto text-reset text-decoration-none pointer-event`}
            >
              Payroll Print <FaAnglesRight />
              <label className="small fw-medium ms-2">
                Periods: {fnDateEn(id).format('MM/YYYY')}
              </label>
            </Link>
          </div>
        </TextNavTitle>
      </NavTitle>
      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3  ">
            <Row>
              <Col md={4}>
                <span className="mb-0 small">Total: {totalRows}</span>
              </Col>
              <Col md={8} className="d-flex justify-content-end">
                <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                  <div style={{ minWidth: 280 }}>
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </div>
                </Form>
              </Col>
            </Row>
          </div>

          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="font-title-table">
                <th className="fw-normal ">#</th>

                <th className="fw-normal ">Periods</th>
                <th className="fw-normal ">Code</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal">Payment Type</th>

                <th className="fw-normal ">Type</th>
                <th
                  className="fw-normal text-end"
                  style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
                >
                  Income
                </th>
                <th
                  className="fw-normal text-end"
                  style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
                >
                  Deduction
                </th>
                <th
                  className="fw-normal "
                  style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
                >
                  Unit Type
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <TableSkeletonBody colSpan={9} rowSpan={7} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="font-small-2 align-middle" key={i}>
                    <td className="align-top">
                      {' '}
                      {page * totalLimits - totalLimits + i + 1}
                    </td>
                    <td className="align-top">
                      {fnDateEn(d.paymentPeriodDate).format('MM/YYYY')}
                    </td>
                    <td className="align-top">{d.code}</td>
                    <td className="align-top">
                      {d.titleTh}
                      {d.nameTh} {d.surnameTh}
                    </td>
                    <td className="align-top">
                      {/* {d.paymentName} */}

                      {d.details.map((item, index) => (
                        <p>
                          {index + 1}. {item.paymentName}
                        </p>
                      ))}
                    </td>
                    <td className="align-top">
                      {/* {d.paymentAmounts?.toLocaleString()} */}
                      {d.details.map((item) => (
                        <p>{item.paymentListTypeName}</p>
                      ))}
                    </td>

                    <td className="align-top">
                      {d.details.map((item) =>
                        item.paymentListTypeId === 1 ? ( //Income
                          <p className={`text-end`}>
                            {item.paymentAmounts?.toLocaleString()}
                          </p>
                        ) : (
                          <p className={`opacity-0 `}>-</p>
                        )
                      )}
                    </td>
                    <td className="align-top">
                      {d.details.map((item) =>
                        item.paymentListTypeId === 2 ? ( //Deduction
                          <p className={`text-end`}>
                            {item.paymentAmounts?.toLocaleString()}
                          </p>
                        ) : (
                          <p className={`opacity-0 `}>-</p>
                        )
                      )}
                    </td>
                    <td className="align-top">
                      {d.details.map((item) => (
                        <p>{item.paymentDataTypeName}</p>
                      ))}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="table-body">
                  <td colSpan={9} className="text-center">
                    -No Data-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>
    </div>
  )
}
